export default {
  namespaced: true,

  actions : {
    async getMeta(context){
      return await context.dispatch({
        type        : 'requests/apiRequest',
        method      : 'get',
        requestPath : '/api/v1/users/meta',
      }, {root: true});
    },

    async setThumbnail(context, payload){
      return await context.dispatch({
        type        : 'requests/apiRequest',
        method      : 'post',
        requestPath : '/api/v1/users/set-thumbnail',
        parameters  : {
          character_id  : payload.characterId,
          image_string  : payload.imageString,
        }
      }, {root: true});
    },

    async changePassword(context, payload){
      return await context.dispatch({
        type        : 'requests/apiRequest',
        method      : 'post',
        requestPath : '/api/v1/users/password',
        parameters  : {
          current_password  : payload.current_password,
          new_password      : payload.new_password
        }
      }, {root: true});
    },

    async changeName(context, payload){
      return await context.dispatch({
        type        : 'requests/apiRequest',
        method      : 'post',
        requestPath : '/api/v1/users/displayname',
        parameters  : {
          displayname : payload.displayname
        }
      }, {root: true});
    },

    async changeEmail(context, payload){
      return await context.dispatch({
        type        : 'requests/apiRequest',
        method      : 'post',
        requestPath : '/api/v1/users/email',
        parameters  : {
          email : payload.email
        }
      }, {root: true});
    },
    
    async emailConfirmation(context, payload){
      return await context.dispatch({
        type        : 'requests/apiRequest',
        method      : 'get',
        requestPath : '/api/v1/users/email-confirmation/'+payload.token,
      }, {root: true});
    },

    async changeUserCharacterIDName(context, payload){
      return await context.dispatch({
        type        : 'requests/apiRequest',
        method      : 'post',
        requestPath : '/api/v1/users/update-username',
        parameters  : {
          name  : payload.name
        }
      }, {root: true});
    }
  }
}